import { produce } from "immer"
const initalState = {
    data: {
        categories: [],
        experience: [],
        socialMedia: [],
        taskType: [],
        attachment: []
    }
}

const AllTypesCommonReducer = (state = initalState, action) => {
    switch (action.type) {
        case "ADD_CATEGROY":
            return produce((state), draft => {

                draft.data.categories = action.payload
            })

        case "ADD_EXPERIENCE":
            return produce(state, (draft) => {
                draft.data.experience = action.payload
            })

        case "ADD_SOCIAL_MEDIA":
            return produce(state, (draft) => {
                draft.data.socialMedia = action.payload
            })
        // ADD_ATACHMENT
        case "ADD_TASK_TYPE":
            return produce(state, (draft) => {
                draft.data.taskType = action.payload

            })
        case "ADD_ATACHMENT":
            return produce(state, (draft) => {
                draft.data.attachment = action.payload

            })


        default:
            return state
    }
}

export default AllTypesCommonReducer